<template>
  <span class="type-badge">
    {{ type === 'online' ? 'EN LIGNE' : 'SUR PLACE' }}
  </span>
</template>

<script setup lang="ts">
import type { EventType } from '@/types/Event';

withDefaults(
  defineProps<{
    type: Exclude<EventType, 'ALL'>;
    size?: 'sm' | 'md';
  }>(),
  { size: 'sm' },
);
</script>
